// 全局状态管理，不走持久化
export default {
  namespaced: true,
  state: {
    appKey: '', // 七鱼初始化企业id
    defaultGroupId: '', // 默认客服分组id
  },
  mutations: {
    // 存储七鱼appkey
    setAppkey(state, data) {
      state.appKey = data;
    },
    // 存储默认客服组id
    setDefaultGroupId(state, data) {
      state.defaultGroupId = data;
    },
  },
};
